import Page from '@service-victoria/component-library/components/Page';
import { Button } from '@service-victoria/component-library/components/Button';
import Text from '@service-victoria/component-library/components/Text';
import { device } from '@service-victoria/component-library/utils/device';
import * as React from 'react';
import styled from 'styled-components';

export type ComponentProps = Record<string, never>;

const Content = styled.div`
  @media ${device.isTablet}, ${device.isMobile} {
    padding: 20px;
  }
`;

const Heading = styled(Text.Heading.H1).attrs({ fontWeight: 'bold' })`
  margin-top: 20px;
`;

const HomeButton = styled(Button).attrs({
  type: 'button',
  onClick: () => (window.location.href = '/')
})`
  margin-top: 40px;
`;

const NoMatch: React.FC<ComponentProps> = () => (
  <Page
    title=''
    showFooter
    headerProps={{
      fetchItemsFromAPI: true,
      showSideNav: true
    }}>
    <Content>
      <Heading>404 page not found</Heading>
      <Text.Body>
        We&apos;ve logged that you arrived at this page and we&apos;ll look into it.
      </Text.Body>
      <HomeButton>Back to home</HomeButton>
    </Content>
  </Page>
);

export default NoMatch;
